export default __webpack_public_path__ + "static/SRUS P149 - Especification Del Producto y Datos Técnicos-665e23421f386bab5ea58ec3e883b9d2.pdf";